import React from "react";
import ReactTooltip from "react-tooltip";

import { EllipsisTooltipText } from "../../common/components/EllipsisTextWithTooltip";
import { getDisplayNameFromKey, getTileName, isRecomSectionBreak } from "../utils";
import actions from "../actions";
import { useDispatch } from "react-redux";

const ChartItem = ({
    item,
    setSmartChartData,
    chartItemData = null,
    currentBand,
    openChartItemConfigModal,
    provided,
    index,
    entity,
    toggleImageListForBandModal,
    toggleImageBandDeleteConfirmationModal,
    editImageBand,
    isEdit = false,
    updatePageBreakConfig,
    isExcelExport = false,
    isSkeletonView,
    buildingMfilter = [],
    additionMfilter = [],
    siteMfilter = [],
    currentChartData,
    handleShowDocPreview,
    isPreviewDocLoading,
    selectedDocPreview,
    updateDocHeaderConfig,
    entireChartData = {},
    openExecutiveSummaryHierarchyConfig,
    onOpenNestedExecutiveSummaryGroup,
    embedInHierarchyConfigModal = false,
    chartItemTooltipId,
    hierarchyModalReadOnly = false,
    hideMemoImageEditControls = false
}) => {
    const dispatch = useDispatch();
    const tileName = getTileName(item);
    const displayName = getDisplayNameFromKey(item.name, item.isUserDoc);
    const bandSurface = item?.flatBandData || item?.tileData;
    const innerHierarchyData = item?.innerHierarchyNodeId;
    const chartTipId = chartItemTooltipId ?? `sm-charts-chart-item${entity}`;
    const tooltipId = embedInHierarchyConfigModal ? `${chartTipId}-bottom` : chartTipId;
    const hierReadOnly = embedInHierarchyConfigModal && hierarchyModalReadOnly;

    return (
        <div className="drag-item" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} key={`draggable-${index}`}>
            <div className="top-sec">
                <div className="icon">
                    <img src="/img/icon-squre.svg" />
                </div>
                {item.isImageBand ||
                item.isCAband ||
                item.isRecommendation ||
                item.isMultipleRecommendation ||
                item.isAssetOnePager ||
                item?.isMemo ||
                item?.isUserDoc ||
                (item?.isFilterReport && item?.isSelected) ||
                (item?.isTOC && item?.isSelected) ||
                (item?.isDynamicBBI && item?.isSelected) ||
                (item?.isDynamicSystem && item?.isSelected) ||
                (item?.name?.startsWith("asset_band") && entity === "project" && item?.isSelected) ||
                ((item?.isDynamicBAI || item?.name === "energy_band") && item?.isSelected) ||
                (item?.isExecutiveSummaryParent && item?.isSelected) ? (
                    <ReactTooltip id={tooltipId} effect="solid" place={embedInHierarchyConfigModal ? "left" : "bottom"} backgroundColor="#007bff" />
                ) : null}
                <div className="icon-rght-b">
                    {item?.isImageBand ? (
                        <div class="wrap-icon d-flex">
                            <div
                                class="edt-icn ey-icn cursor-hand"
                                data-tip="View Selected Images"
                                data-for={tooltipId}
                                onClick={() =>
                                    toggleImageListForBandModal(
                                        {
                                            bandName: currentBand,
                                            chartKey: item.isImageBand ? item.docKey : item.name,
                                            entity: entity,
                                            itemConfig: item.config,
                                            isImageBand: item.isImageBand,
                                            hierarchyNodeId: innerHierarchyData
                                        },
                                        true
                                    )
                                }
                            >
                                <img src="/img/sm-charts-img-eye.svg" />
                            </div>
                        </div>
                    ) : null}
                    {item.isImageBand && !hierReadOnly ? (
                        <div class="wrap-icon d-flex">
                            <div
                                class={`edt-icn de-icn cursor-hand eye-ico`}
                                data-tip={bandSurface?.show_captions ? "Remove Image Captions" : "Show Image Captions"}
                                data-for={tooltipId}
                                onClick={() =>
                                    updateDocHeaderConfig(
                                        {
                                            bandName: currentBand,
                                            chartKey: item.docKey,
                                            entity: entity,
                                            name: item.name,
                                            selectedTile: item,
                                            hierarchyNodeId: innerHierarchyData
                                        },
                                        { show_captions: !(bandSurface?.show_captions ?? false) }
                                    )
                                }
                            >
                                <img src={`/img/${(bandSurface?.show_captions ?? false) ? "image-caption-on.svg" : "image-caption-off.svg"}`} />
                            </div>
                        </div>
                    ) : null}
                    {item.isIndividualBuilding ? (
                        <>
                            <ReactTooltip id={`sm-charts-main-indv${entity}`} effect="solid" place="bottom" backgroundColor="#007bff" />
                            <div
                                className="icon-b"
                                data-tip="This chart/table will repeat for every building in scope"
                                data-for={`sm-charts-main-indv${entity}`}
                            >
                                <img src={`/img/sm-charts-all-buildings.svg`} />
                            </div>
                        </>
                    ) : null}
                    <div class="wrap-icon d-flex">
                        {(bandSurface?.id || item?.tileData?.id) && !hierReadOnly && (
                            <div
                                class="edt-icn de-icn cursor-hand eye-ico"
                                data-tip="View Preview"
                                data-for={tooltipId}
                                onClick={() => handleShowDocPreview(bandSurface?.id || item?.tileData?.id)}
                            >
                                {isPreviewDocLoading && selectedDocPreview === (bandSurface?.id || item?.tileData?.id) ? (
                                    <span className="spinner-border spinner-border-sm pl-2" role="status" />
                                ) : (
                                    <img src="/img/eye-ico-ic.svg" alt="" />
                                )}
                            </div>
                        )}
                        {(item?.isMemo || (item?.isExecutiveSummaryParent && !item?.tileData?.is_grouped_band)) && !hideMemoImageEditControls ? (
                            <div
                                class="edt-icn ey-icn cursor-hand"
                                data-tip={"View Text"}
                                data-for={tooltipId}
                                onClick={() =>
                                    (entity === "project" || entity === "assets" || entity === "energy_mng") &&
                                    (item.isSelected || hierReadOnly) &&
                                    openChartItemConfigModal({
                                        bandName: currentBand,
                                        chartKey: item?.isMemo || item?.isExecutiveSummaryParent ? item.docKey : item.name,
                                        entity: entity,
                                        itemConfig: item.config,
                                        isImageBand: item.isImageBand,
                                        isMemo: item?.isMemo || item?.isExecutiveSummaryParent,
                                        hierarchyNodeId: innerHierarchyData,
                                        isViewOnly: true,
                                        recomType: ""
                                    })
                                }
                            >
                                <img src="/img/sm-charts-img-eye.svg" alt="" />
                            </div>
                        ) : null}
                        {(bandSurface?.id || item?.tileData?.id) && !isExcelExport && !hierReadOnly && (
                            <div
                                class={`${(entireChartData?.project?.band1?.custom_header_keys || [])?.length ? "" : "cursor-disabled"} edt-icn de-icn cursor-hand eye-ico`}
                                data-tip={
                                    bandSurface?.include_custom_header
                                        ? "Disable Header"
                                        : !(entireChartData?.project?.band1?.custom_header_keys || [])?.length
                                          ? "Configure the header to enable"
                                          : "Enable Header"
                                }
                                data-for={tooltipId}
                                onClick={() => {
                                    if ((entireChartData?.project?.band1?.custom_header_keys || [])?.length)
                                        updateDocHeaderConfig({
                                            bandName: currentBand,
                                            chartKey: item.docKey,
                                            entity: entity,
                                            name: item.name,
                                            selectedTile: item,
                                            hierarchyNodeId: innerHierarchyData,
                                            include_custom_header: !(bandSurface?.include_custom_header || false)
                                        });
                                }}
                            >
                                <img src={`/img/${bandSurface?.include_custom_header ? "header-on.svg" : "header.svg"}`} />
                            </div>
                        )}

                        {!hierReadOnly &&
                        !hideMemoImageEditControls &&
                        (item?.isMemo || (item?.isExecutiveSummaryParent && !item?.tileData?.is_grouped_band)) ? (
                            <div
                                class="edt-icn cursor-hand"
                                data-tip={item?.isExecutiveSummaryParent ? "Edit Text" : item.isMemo ? "Edit Text" : ""}
                                data-for={tooltipId}
                                onClick={() =>
                                    (entity === "project" || entity === "assets" || entity === "energy_mng") &&
                                    item.isSelected &&
                                    openChartItemConfigModal({
                                        bandName: currentBand,
                                        chartKey: item?.isMemo || item?.isExecutiveSummaryParent ? item.docKey : item.name,
                                        entity: entity,
                                        itemConfig: item.config,
                                        isImageBand: item.isImageBand,
                                        isMemo: item?.isMemo || item?.isExecutiveSummaryParent,
                                        hierarchyNodeId: innerHierarchyData,
                                        recomType: item.isMultipleRecommendation
                                            ? "multiple"
                                            : item.isOnePager
                                              ? "onepager"
                                              : item.isRecommendation
                                                ? "normal"
                                                : ""
                                    })
                                }
                            >
                                <i class="fa fa-edit text-edit"></i>
                            </div>
                        ) : null}
                        {!hierReadOnly &&
                        (item.isRecommendation ||
                            item.isCAband ||
                            item?.isMultipleRecommendation ||
                            item?.isMemo ||
                            item?.isUserDoc ||
                            item?.isBbi ||
                            item?.isBsi ||
                            item?.isBai ||
                            (item?.isExecutiveSummaryParent && item?.isSelected) ||
                            ((item?.isFilterReport || item?.hasPageBreak) && item?.isSelected)) &&
                        !isExcelExport ? (
                            <div
                                class="edt-icn ey-icn cursor-hand"
                                data-tip={
                                    isRecomSectionBreak(bandSurface, item?.name === "energy_band" ? false : true)
                                        ? "add page break"
                                        : "remove page break"
                                }
                                data-for={tooltipId}
                                onClick={() => {
                                    updatePageBreakConfig(
                                        {
                                            bandName: currentBand,
                                            chartKey: item.docKey,
                                            entity: entity,
                                            name: item.name,
                                            selectedTile: item,
                                            hierarchyNodeId: innerHierarchyData,
                                            remove_section_break: !isRecomSectionBreak(bandSurface, item?.name === "energy_band" ? false : true)
                                        },
                                        "remove_section_break"
                                    );
                                }}
                            >
                                <img
                                    src={`/img/${
                                        isRecomSectionBreak(bandSurface, item?.name === "energy_band" ? false : true)
                                            ? "section-break-recom-dis.svg"
                                            : "section-break-recom.svg"
                                    }`}
                                />
                            </div>
                        ) : null}
                        {!hierReadOnly &&
                        !hideMemoImageEditControls &&
                        (item.isImageBand ||
                        item.isMultipleRecommendation ||
                        item.isRecommendation ||
                        item.isOnePager ||
                        item?.isMemo ||
                        (item?.isFilterReport && item?.isSelected) ||
                        (item.isBsi && item?.isSelected) ||
                        (item?.isTOC && item?.isSelected) ||
                        (item.isDynamicSystem && item?.isSelected) ||
                        (item.name.startsWith("Comparative Analysis Band") && item?.isSelected) ||
                        (item.isSortedRecom && item?.isSelected) ||
                        (item.isDynamicBBI && item?.isSelected) ||
                        (item.isDynamicBSI && item?.isSelected) ||
                        (item.isBai && item?.isSelected) ||
                        (item.isBbi && item?.isSelected) ||
                        item?.isExecutiveSummaryParent) ? (
                            <div
                                class="edt-icn cursor-hand"
                                data-tip={
                                    item.isImageBand
                                        ? "Edit Image Band Name"
                                        : item.isMultipleRecommendation
                                        ? "Edit Recommendation Summary Band Name"
                                        : item.isRecommendation
                                        ? "Edit Recommendation Table Band Name"
                                        : item.isOnePager
                                        ? "Edit One Pager Band Name"
                                        : item.isMemo
                                        ? "Edit Text Band Name"
                                        : item?.isFilterReport
                                        ? "Edit Master Filter"
                                        : item?.isTOC
                                        ? "Edit Table of Content"
                                        : item?.isBsi
                                        ? "Edit BSI/Stoplight heading"
                                        : item?.isDynamicSystem
                                        ? "Edit System Name"
                                        : item?.isSortedRecom
                                        ? "Edit Sorted Recommendation"
                                        : item?.isDynamicSystem
                                        ? "Edit System Name"
                                        : item.isDynamicBBI || item?.isBbi
                                        ? "Edit BBI/Stoplight chart"
                                        : item?.isDynamicBSI || item?.isBsi
                                        ? "Edit BSI/Stoplight chart"
                                        : item.isDynamicBAI || item?.isBai
                                        ? "Edit BAI/Stoplight chart"
                                        : item?.isExecutiveSummaryParent
                                        ? "Edit executive summary band name"
                                        :"Edit Comparative Analysis Band"
                                }
                                data-for={tooltipId}
                                onClick={() =>
                                    editImageBand(
                                        {
                                            bandName: currentBand,
                                            chartKey: item.docKey,
                                            entity: entity,
                                            name: item.name || "Image Band",
                                            selectedTile: item
                                        },
                                        "image"
                                    )
                                }
                            >
                                <img src="/img/sm-charts-img-edit.svg" />
                            </div>
                        ) : null}
                        {!hierReadOnly &&
                        (item.isImageBand ||
                        item.isCAband ||
                        item.isMultipleRecommendation ||
                        item.isRecommendation ||
                        item.isOnePager ||
                        (item.isUserDoc && !item.isImage) ||
                        item.isDynamicSystem ||
                        item?.isBai ||
                        item?.isBsi ||
                        item?.isBbi ||
                        item?.isMemo||
                        item?.isExecutiveSummaryParent) ? (
                            <div
                                class="edt-icn de-icn cursor-hand"
                                data-tip={
                                    item.isImageBand
                                        ? "Delete Image Band"
                                        : item.isCAband
                                        ? "Delete Comparative Analysis Band"
                                        : item.isMultipleRecommendation
                                        ? "Delete Recommendation Summary Band"
                                        : item.isRecommendation
                                        ? "Delete Recommendation Table Band"
                                        : item.isOnePager
                                        ? "Delete One Pager Band"
                                        : item.isMemo
                                        ? "Delete Text Band"
                                        : item.isDynamicMasterFilter
                                        ? "Delete Filter Report"
                                        : item.isBbi || item?.isBsi || item?.isBai
                                        ? `Delete ${item?.name}`
                                        : item?.isDynamicSystem
                                        ? "Delete System"
                                        : item?.isExecutiveSummaryParent
                                        ? "Delete executive summary band"
                                        : "Delete User Document"
                                }
                                data-for={tooltipId}
                                onClick={() =>
                                    toggleImageBandDeleteConfirmationModal({
                                        bandName: currentBand,
                                        chartKey: item.docKey,
                                        entity: entity,
                                        ...(embedInHierarchyConfigModal && innerHierarchyData ? { execSumHierarchyChildId: innerHierarchyData } : {}),
                                        type: item.isImageBand
                                            ? "Image Band"
                                            : item.isCAband
                                            ? "Comparative Analysis Band"
                                            : item.isMultipleRecommendation
                                            ? "Recommendation Summary Band"
                                            : item.isRecommendation
                                            ? "Recommendation Table Band"
                                            : item.isOnePager
                                            ? "One Pager Band"
                                            : item.isMemo
                                            ? "Memo"
                                            : item.isBbi || item?.isDynamicSystem || item?.isBai || item?.isBsi
                                            ? item?.name
                                            : item?.isExecutiveSummaryParent
                                            ? "Executive Summary Band"
                                            : "Document"
                                    })
                                }
                            >
                                <img src="/img/sm-charts-img-delete.svg" />
                            </div>
                        ) : null}

                        {!embedInHierarchyConfigModal ? (
                        <div className="checkbox">
                            <label
                                className={`container-check green-check ${
                                    isSkeletonView ||
                                    (item.isBbi && (!buildingMfilter.length || buildingMfilter.length > 1)) ||
                                    (item.isBai && (!additionMfilter.length || additionMfilter.length > 1)) ||
                                    (item.isBsi && (!siteMfilter.length || siteMfilter.length > 1))
                                        ? "disabled-btn"
                                        : ""
                                }`}
                            >
                                <input
                                    type="checkbox"
                                    name="is_bold"
                                    onClick={e => {
                                        if ((item?.isBbi || item?.isBsi || item?.isBai) && !item.isSelected) {
                                            dispatch(
                                                actions?.getBuildingTrades(
                                                    {
                                                        project_id: currentChartData?.mfilter?.project_ids?.[0],
                                                        ...(item?.isBbi
                                                            ? { building_id: buildingMfilter?.[0] }
                                                            : item?.isBai
                                                            ? { addition_id: additionMfilter?.[0] }
                                                            : { site_id: siteMfilter?.[0] })
                                                    },
                                                    item?.isBsi
                                                )
                                            );
                                        }
                                        setSmartChartData("customize_chart", {
                                            bandName: currentBand,
                                            chartKey:
                                                item.isUserDoc ||
                                                item.isImageBand ||
                                                item.isBbi ||
                                                item.isBsi ||
                                                item.isBai ||
                                                item?.isRecommendation ||
                                                item?.isMultipleRecommendation||
                                                item?.isOnePager||
                                                item?.isAssetOnePager||
                                                item?.isExecutiveSummaryParent ||
                                                item?.tileData?.is_building_exec_sum ||
                                                item?.isMemo ||
                                                item?.isFilterReport ||
                                                item.name.startsWith("Comparative Analysis Band") ||
                                                item?.isTOC ||
                                                item?.isDynamicSystem ||
                                                item?.isSortedRecom
                                                    ? item.docKey
                                                    : item.name,
                                            is_remove: !e.target.checked,
                                            defaultValue: item.defaultValue,
                                            entity: entity
                                        });
                                    }}
                                    checked={item.isSelected}
                                    disabled={
                                        isSkeletonView ||
                                        (item.isBbi && (!buildingMfilter.length || buildingMfilter.length > 1)) ||
                                        (item.isBai && (!additionMfilter.length || additionMfilter.length > 1)) ||
                                        (item.isBsi && (!siteMfilter.length || siteMfilter.length > 1))
                                    }
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="cont-sec mt-2 pl-2">
                <div className="icons-sec">
                    <img src={`/img/${item.entityIcon}`} />
                </div>
                <div className="tile-name-badge-container">
                    <EllipsisTooltipText text={displayName} className="chart-item-title-text" asHeading />
                    {tileName && <span className="tile-name-badge mt-1">{tileName}</span>}
                </div>
            </div>
            {(item.hasConfig && (entity === "project" || entity === "assets" || entity === "energy_mng")) ||
            (item?.name?.startsWith("Comparative Analysis Band") && entity === "project") ? (
                <div className="fot-sec top-border">
                    <div className="fot-select">
                        {item.isRecommendation ||
                        (!item.isSortedRecom &&
                            !isExcelExport &&
                            !item?.isMemo &&
                            !item?.isExecutiveSummaryParent &&
                            !item.isBsi &&
                            !item?.isBbi &&
                            !item?.isBai &&
                            !item?.name?.startsWith("Comparative Analysis Band") &&
                            !item?.name?.startsWith("asset_band") &&
                            item.name !== "energy_band" &&
                            !hideMemoImageEditControls) ? (
                            <>
                                {!(
                                    (item?.tileData?.band1?.config_filter && Object.keys(item.tileData.band1.config_filter).length > 0) ||
                                    (item?.tileData?.config_filter && Object.keys(item.tileData.config_filter).length > 0) ||
                                    item?.tileData?.band1?.mfilter?.recommendations?.length === 0 ||
                                    item?.tileData?.recommendations?.length === 0 ||
                                    item?.tileData?.band1?.mfilter?.asset_ids?.length === 0
                                ) && (
                                    <span
                                        className={`badge ${
                                            (item.isImageBand || item.isMultipleRecommendation || item.isRecommendation || item.isOnePager) &&
                                            !item.totalChartCount &&
                                            item.isSelected
                                                ? "sm-chart-chart-count-indicator"
                                                : ""
                                        }`}
                                    >
                                        {item?.totalChartCount}
                                    </span>
                                )}
                                <span className="nme">
                                    {item.isMultipleRecommendation || item.isRecommendation || item.isOnePager
                                        ? item?.isAssetOnePager
                                            ? (item?.tileData?.band1?.config_filter && Object.keys(item.tileData.band1.config_filter).length > 0) ||
                                              (item?.tileData?.config_filter && Object.keys(item.tileData.config_filter).length > 0) ||
                                              item?.tileData?.band1?.mfilter?.asset_ids?.length === 0
                                                ? "All Assets"
                                                : "Assets"
                                            : (item?.tileData?.band1?.config_filter && Object.keys(item.tileData.band1.config_filter).length > 0) ||
                                              (item?.tileData?.config_filter && Object.keys(item.tileData.config_filter).length > 0) ||
                                              item?.tileData?.band1?.mfilter?.recommendations?.length === 0 ||
                                              item?.tileData?.recommendations?.length === 0
                                            ? "All Recommendations"
                                            : "Recommendations"
                                        : `Selected ${item.isImageBand ? "Images" : "Charts"}`}
                                </span>
                            </>
                        ) : null}
                    </div>
                    <div className="btn-area">
                        <div className="icon"></div>
                        {item.isImageBand && !hierReadOnly && !hideMemoImageEditControls ? (
                            <button
                                class="btn butn-img-select"
                                data-tip="Select Images"
                                data-for={tooltipId}
                                onClick={() =>
                                    toggleImageListForBandModal({
                                        bandName: currentBand,
                                        chartKey: item.isImageBand ? item.docKey : item.name,
                                        entity: entity,
                                        itemConfig: item.config,
                                        isImageBand: item.isImageBand,
                                        hierarchyNodeId: innerHierarchyData
                                    })
                                }
                            >
                                <img src="/img/sm-charts-img-select.svg" />
                            </button>
                        ) : null}
                        {!(isEdit && item.name.includes("multi_recommendation")) && !(item.isImageBand && hideMemoImageEditControls) ? (
                            <button
                                className="btn btn-conf"
                                onClick={() => {
                                    if (
                                        (entity === "project" || entity === "assets" || entity === "energy_mng") &&
                                        (item.isSelected || hierReadOnly)
                                    ) {
                                        if (item?.isExecutiveSummaryParent) {
                                            if (embedInHierarchyConfigModal && onOpenNestedExecutiveSummaryGroup) {
                                                onOpenNestedExecutiveSummaryGroup(item?.tileData || item?.flatBandData);
                                                return;
                                            }
                                            openExecutiveSummaryHierarchyConfig?.({
                                                entity,
                                                bandName: currentBand,
                                                chartKey: item.docKey
                                            });
                                            return;
                                        }
                                        item?.name?.startsWith("Comparative Analysis Band") &&
                                        Object.keys(item?.tileData || {})?.includes("reverse_cmp_analysis")
                                            ? editImageBand(
                                                  {
                                                      bandName: currentBand,
                                                      chartKey: item.docKey,
                                                      entity: entity,
                                                      name: item.name,
                                                      selectedTile: item
                                                  },
                                                  "CA"
                                              )
                                            : openChartItemConfigModal({
                                                  bandName: currentBand,
                                                  chartKey:
                                                      item.isImageBand ||
                                                      item.isMultipleRecommendation ||
                                                      item.isRecommendation ||
                                                      item.isOnePager ||
                                                      item?.isSortedRecom ||
                                                      item?.isDynamicSystem ||
                                                      item?.isDynamicBBI ||
                                                      item?.isDynamicBSI ||
                                                      item?.isDynamicBAI
                                                          ? item.docKey
                                                          : item.name,
                                                  entity: entity,
                                                  itemConfig: item.config,
                                                  isImageBand: item.isImageBand,
                                                  isBbi: item?.isBbi,
                                                  isBai: item?.isBai,
                                                  isBsi: item?.isBsi,
                                                  isDynamicBBI: item?.isDynamicBBI,
                                                  isDynamicBSI: item?.isDynamicBSI,
                                                  isDynamicBAI: item?.isDynamicBAI,
                                                  recomType: item.isMultipleRecommendation
                                                      ? "multiple"
                                                      : item?.isAsset || (item?.isAssetOnePager && entity === "project")
                                                      ? "asset"
                                                      : item.isOnePager
                                                      ? "onepager"
                                                      : item.isRecommendation
                                                      ? "normal"
                                                      : "",
                                                      hierarchyNodeId: innerHierarchyData
                                              });
                                    }
                                }}
                            >
                                {item?.isExecutiveSummaryParent ? "View Child Bands" : "Configure"} <img src="/img/blue_arrow_right.svg" alt="" />
                            </button>
                        ) : null}
                    </div>
                </div>
            ) : null}
            {provided.placeholder}
        </div>
    );
};
export default ChartItem;
